import util from '../../../util'
import PickupApi from "../../../api/modules/PickupApi";

const searchPickups = async ({commit}, payload) => {
  try {
    const {context, ...data} = payload;
    return await PickupApi.searchPickups(context, data);
  } catch (error) {
    console.error("Error al buscar recojos:", error);
    throw error;
  }
};

const loadPickupList = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.get(`api/pickups?${payload.params}`, {headers}).then((response) => {
      commit('setPickupList', response.data);
      resolve(response.data);
    }).catch(error => {
      if (error.response) {
        util.showDialogError(payload.context, 'Ocurrió un error al cargar los recojos.')
        reject(error.response)
      } else reject(error)

    });
  })
}

const loadTrackingPickupList = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.get(`api/pickups/tracking/${payload.idPickup}`, {headers}).then((response) => {
      resolve(response.data)
    }).catch(error => {
      if (error.response) {
        util.showDialogError(payload.context, 'Ocurrió un error al cargar el tracking del recojo.')
        reject(error.response)
      } else reject(error)

    });
  })
}

const approvePickup = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.patch(`api/pickups/${payload.idPickup}/${payload.numberGuia}/approve`, {}, {headers}).then((response) => {
      commit('setPickupList', response.data)
      resolve(response.data)
    }).catch(error => {
      if (error.response) {
        util.showDialogError(payload.context, 'Ocurrió un error al aprobar el recojo.')
        reject(error.response)
      } else reject(error)

    });
  })
}

const transportPickup = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.patch(`api/pickups/${payload.idPickup}/transport`, {}, {headers}).then((response) => {
      commit('setPickupList', response.data)
      resolve(response.data)
    }).catch(error => {
      if (error.response) {
        util.showDialogError(payload.context, 'Ocurrió un error al poner el recojo en transporte.')
        reject(error.response)
      } else reject(error)
    });
  })
}

const confirmPickup = (_, payload) => {
  return PickupApi.confirmPickup(payload.context, payload.idPickup, payload.request);
};

const updatePickupDate = async ({commit}, payload) => {
  try {
    const {context, ...request} = payload;
    const response = await PickupApi.updatePickupDate(context, request);
    return response;
  } catch (error) {
    console.error("Error al actualizar la fecha de recojo:", error);
    throw error;
  }
};

const loadItemsLocationFromPickup = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.get(`api/pickups/${payload.idPickup}/items`, {headers}).then((response) => {
      resolve(response.data)
    }).catch(error => {
      if (error.response) {
        util.showDialogError(payload.context, 'Ocurrió un error al cargar las ubicaciones de los files.')
        reject(error.response)
      } else reject(error)

    });
  })
}

const registerPickup = async ({commit}, payload) => {
  try {
    return await PickupApi.registerPickup(payload.context, payload.pickup);
  } catch (e) {
    console.error("Error registrando recojo automático:", e);
    throw e;
  }
};

const exportPickupsExcel = async ({commit}, payload) => {
  try {
    const {context, filters} = payload;
    return await PickupApi.exportPickupsExcel(context, filters);
  } catch (error) {
    console.error("Error al exportar Excel de recojos:", error);
    throw error;
  }
};

const exportPickupsPdf = async ({commit}, payload) => {
  try {
    const {context, filters} = payload;
    return await PickupApi.exportPickupsPdf(context, filters);
  } catch (error) {
    console.error("Error al exportar PDF de recojos:", error);
    throw error;
  }
};

const downloadVaultPickupOrderPdf = async ({commit}, payload) => {
  try {
    const {context, id} = payload;
    const response = await PickupApi.downloadVaultPickupOrderPdf(context, id);
    return response;
  } catch (error) {
    console.error("Error al descargar PDF de orden de recojo:", error);
    throw error;
  }
};

export default {
  searchPickups,
  loadPickupList,
  loadTrackingPickupList,
  approvePickup,
  transportPickup,
  confirmPickup,
  updatePickupDate,
  loadItemsLocationFromPickup,
  registerPickup,
  exportPickupsExcel,
  exportPickupsPdf,
  downloadVaultPickupOrderPdf,
};



// WEBPACK FOOTER //
// ./src/store/modules/pickup/actions.js